import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, FormGroup, Modal, Row } from "react-bootstrap";
import Srcollbar from "react-perfect-scrollbar";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import {
  GET_MSSG_WITH_VALIDATE_LTI_FATALITY,
  STAFFEMPLOYER,
  highSeverities,
  injuryOutcomes,
  ltiFormRules,
  severities,
} from "../CONSTANTS";
import { SearchableSelect } from "app/Components/SearchableSelect/SSingleSelect";
import Input from "app/Components/_form/Input/Input";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import MultiSelectTwo from "app/Components/SearchableSelect/MultiSelectTwo";
import { bodyLabel } from "app/Components/BodyPartComponent/CONSTANT";
import {
  getIncidentReportById,
  ltiHoursUpdate,
} from "app/_services/ehs/ehsIncidentServices";
import toastr from "toastr";
import { getEmployee } from "app/_services/UserManagement/EmployeeService";
import { capitalizeName } from "app/_helpers/helper";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import { getContractor } from "app/_services/Contractor/ContractorService";
import { Validation } from "app/_helpers/validation/Validation";
import { checkForLt } from "../IncidentReportForm";
import { Link } from "react-router-dom";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { ACTIVE_MODULE } from "app/_constants/constant";
import ErrorPopup from "../ErrorPopup";
import { confirmAlert } from "react-confirm-alert";

const LtiUpdateForm = ({ match: { params }, history }) => {
  const [ltiForm, setLtiForm] = useState([]);
  const [fetchIncidentRow, setFetchIncidentRow] = useState({});
  const [error, setError] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [contractorsStaff, setContractorsStaff] = useState([]);
  const [contractors, setContractors] = useState([]);
  // const [show, setShow] = useState(false);
  // const [popupMssg, setPopupMssg] = useState("");
  // const [isOptionalPopup, setIsOptionalPopup] = useState(false);

  const BODY_PART_LIST = [
    ...Object.keys(bodyLabel).map((d) => ({ label: bodyLabel[d], value: d })),
  ];

  useEffect(() => {
    if (!params.id) return;

    getIncidentReportById(params.id, "role=Reporter").then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/incident-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const { personalDetails } = response.data;

      setFetchIncidentRow(response.data);
      const ltiData = personalDetails?.map((d) => {
        return {
          id: d?.id,
          bodyParts: d?.bodyParts,
          injuryType: d?.injuryType,
          severity: d?.severity,
          outcome: d?.outcome,
          ltiHours: d?.ltiHours,

          type: d?.type,
          name: d?.name,
          phone: d?.phone,
          age: d?.age,
          userId: d?.userId,
          employer: d?.employer,
        };
      });
      setLtiForm(ltiData);
    });
  }, [params.id]);

  const getEmployeeList = useCallback(async () => {
    const response = await getEmployee();
    if (!response?.status) return;

    let data = response?.data?.employees || [];

    setEmployeeList(
      data
        ?.filter((obj) => obj?.employmentStatus === "active")
        .map((d, i) => ({
          ...d,
          name_email_employeeId: `${capitalizeName(d.firstName + " " + d.lastName)} / ${
            d.email
          } / ${d.employeeId}`,
        }))
    );
  }, []);

  const getAllContractorPersonList = useCallback(async () => {
    const response = await getAllContractorPerson();
    if (!response?.status) return;

    let data = response?.data || [];

    setContractorsStaff(
      data
        ?.filter((obj) => obj?.employmentStatus === "active")
        .map((d, i) => ({
          ...d,
          name_aadharNumber_srNo: `${capitalizeName(d.firstName + " " + d.lastName)} / ${
            d.aadharNumber
          } / ${d.srNo}`,
        }))
    );
  }, []);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  useEffect(() => {
    getEmployeeList();
    getAllContractorPersonList();
  }, [getAllContractorPersonList, getEmployeeList]);

  const onChange = (index, name, value) => {
    setLtiForm((prev) =>
      prev.map((d, idx) => {
        if (idx !== index) return d;

        d[name] = value;
        if (name === "bodyParts" && value?.split(",")?.includes("notApplicable")) {
          d.bodyParts = "notApplicable";
        }
        if (name === "outcome") {
          d.ltiHours = 0;
        }
        return d;
      })
    );
  };

  const onSubmit = async (onCallPopup = false) => {
    let flag = 0;
    const errArray = ltiForm.map((data) =>
      data.deleted ? {} : Validation(data, ltiFormRules)
    );
    setError(errArray);

    for (const errObj of errArray)
      for (const key in errObj)
        if (errObj[key]) {
          flag = 1;
          break;
        }
    if (flag !== 0 || !fetchIncidentRow?.id) return;

    // if (!onCallPopup) {
    //   const popupMssgText = GET_MSSG_WITH_VALIDATE_LTI_FATALITY(
    //     fetchIncidentRow,
    //     ltiForm,
    //     setIsOptionalPopup
    //   );
    //   if (popupMssgText) {
    //     setShow(true);
    //     setPopupMssg(popupMssgText);
    //     return;
    //   }
    // }

    let LtFlag = 0;
    let msg = "";
    if (fetchIncidentRow?.type === "lti") {
      msg = checkForLt(ltiForm);
      if (msg) LtFlag = 1;
    }
    if (LtFlag !== 0) {
      toastr.error(msg);
      return;
    }
    const response = await ltiHoursUpdate(
      { ltiHoursData: ltiForm },
      fetchIncidentRow?.id
    );
    if (!response?.status) {
      toastr.error(response?.message);
      return;
    }
    toastr.success(response?.message);
    // setLtiModal(false);
    // setLtiForm([]);
    // setFetchIncidentRow({});
  };

  // const confirmationAlert = useCallback(() => {
  //   confirmAlert({
  //     title: "No LTI information has been entered.",
  //     message: "Are you sure you want to proceed?",
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: (e) => {
  //           onSubmit(true);
  //         },
  //       },
  //       {
  //         label: "No",
  //         onClick: () => {
  //           setIsOptionalPopup(false);
  //         },
  //       },
  //     ],
  //   });
  // }, [onSubmit]);

  // const handleClose = () => {
  //   setShow(false);
  //   setPopupMssg("");
  //   // setIsOptionalPopup(false);
  //   isOptionalPopup && confirmationAlert();
  // };

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path: "/health-safety-and-environment/incident-management",
          },
          {
            name: "View Incidents",
            path: "/health-safety-and-environment/incident-management/view-incidents",
          },
          { name: "Update LTI Info", path: "" },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="card p-3 pb-0 mt-3">
        <div className="d-flex justify-content-between simple-card-title">
          <h3 class="text-capitalize mb-0">Update LTI Info</h3>
        </div>
        <div className="card-body">
          <div className="w-100">
            <div className="table-responsive drillingPlan-plannedEdit">
              <Srcollbar className="workoverCategoryScroll">
                <table className="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th
                        scope="col"
                        colSpan="5"
                        className="text-center personnelDetails"
                      >
                        Personnel Details
                      </th>
                      <th scope="col" colSpan="5" className="text-center injuryDetails">
                        Injury/Illness Details
                      </th>
                      <th scope="col"></th>
                    </tr>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col" style={{ minWidth: 180 }}>
                        Type
                      </th>
                      <th scope="col" style={{ minWidth: 230 }}>
                        Name
                      </th>
                      <th scope="col" style={{ minWidth: 180 }}>
                        Employer
                      </th>
                      <th scope="col" style={{ minWidth: 80 }}>
                        ID
                      </th>
                      {/* <th scope="col" className="w-150">
                        Phone
                      </th> */}
                      <th
                        scope="col"
                        style={{ minWidth: 80, borderRight: "3px solid #dee2e6" }}
                      >
                        Age
                      </th>
                      <th scope="col" style={{ maxWidth: "165px", minWidth: "165px" }}>
                        Type
                      </th>
                      <th scope="col" style={{ maxWidth: "120px", minWidth: "120px" }}>
                        Severity{" "}
                        {/* <CustomPopover
                          placement={"left"}
                          tooltip={
                            <>
                              <table className="table table-bordered mb-0 tooltipTable">
                                <thead>
                                  <tr>
                                    <th>Severity</th>
                                    <th>Description</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {highSeverities.map((x) => {
                                    return (
                                      <tr>
                                        <td>{x.label}</td>
                                        <td>{x.tooltip}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </>
                          }
                        >
                          <BsFillInfoCircleFill />
                        </CustomPopover> */}
                      </th>
                      <th scope="col" style={{ maxWidth: "165px", minWidth: "165px" }}>
                        Body Parts Involved
                      </th>
                      <th scope="col" style={{ maxWidth: "160px", minWidth: "160px" }}>
                        Outcome
                      </th>
                      <th scope="col" style={{ minWidth: 120 }}>
                        LTI Hours
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ltiForm.length ? (
                      ltiForm.map((x, index) => {
                        return x.deleted ? null : (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td>
                              <SearchableSelect
                                name="type"
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                value={x.type}
                                options={["Employee", "Contractor", "Others"]}
                                init="none"
                                array="single"
                                disabled
                              ></SearchableSelect>
                            </td>
                            <td>
                              {x.type === "Employee" ? (
                                <SearchableSelect
                                  options={employeeList.map((employee) => ({
                                    label: employee.name_email_employeeId,
                                    value: employee.id,
                                    optionDetails: employee,
                                  }))}
                                  value={x.userId}
                                  placeholder={"Search by Name / Email Id / Employee Id"}
                                  blankSelect={"none"}
                                  disabled
                                />
                              ) : x.type === "Contractor" ? (
                                <SearchableSelect
                                  options={contractorsStaff.map((staff) => ({
                                    label: staff.name_aadharNumber_srNo,
                                    value: staff.id,
                                    optionDetails: staff,
                                  }))}
                                  value={x.userId}
                                  placeholder={"Search by Name / Aadhar No / Sr No."}
                                  blankSelect={"none"}
                                  disabled
                                />
                              ) : (
                                <Input
                                  name="name"
                                  type="text"
                                  onChange={({ target: { name, value } }) =>
                                    onChange(index, name, value)
                                  }
                                  value={x.name}
                                  className="form-control"
                                  disabled
                                />
                              )}
                              <span className="small text-danger">
                                {error[index]?.name}
                              </span>
                            </td>
                            <td>
                              <FormSelect
                                name="employer"
                                value={x.type === "Contractor" ? +x.employer : x.employer}
                                options={
                                  x.type === "Contractor" ? contractors : STAFFEMPLOYER
                                }
                                KEY_label={
                                  x.type === "Contractor"
                                    ? "contractorLegalEntity"
                                    : "contactPerson"
                                }
                                KEY_value={"id"}
                                blankSelect={"Select"}
                                disabled={true}
                              ></FormSelect>
                            </td>
                            <td>
                              <Input
                                name="userId"
                                type="text"
                                value={x.userId || ""}
                                className="form-control"
                                disabled
                              />
                            </td>
                            <td style={{ borderRight: "3px solid #dee2e6" }}>
                              <Input
                                disabled
                                name="age"
                                type="number"
                                onChange={({ target: { name, value } }) =>
                                  value >= 0 &&
                                  value <= 200 &&
                                  onChange(index, name, value)
                                }
                                value={x.age}
                                className="form-control"
                                // error={personalDetailsErrors[index]?.age}
                              />
                              <span className="small text-danger">
                                {error[index]?.age}
                              </span>
                            </td>
                            <td>
                              <SearchableSelect
                                name="injuryType"
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                value={x.injuryType}
                                options={[
                                  "Not Applicable",
                                  "Unknown",
                                  "Blowout",
                                  "Burn",
                                  "Cardiac Arrest",
                                  "Driving",
                                  "Electrocution",
                                  "Explosion",
                                  "Fall",
                                  "Fever",
                                  "Fracture",
                                  "Gas Inhalation",
                                  "Pain",
                                  "People Conflict",
                                  "Respiratory",
                                  "Slip/Trip",
                                  "Vehicle Accident",
                                  "Unconsciousness",
                                  "Vomiting",
                                ]}
                                init="none"
                                array="single"
                              ></SearchableSelect>
                            </td>
                            <td>
                              <SearchableSelect
                                name="severity"
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                value={x.severity}
                                options={Object.keys(severities)}
                                object={severities}
                                init="none"
                                disabled={x.injuryType === "Not Applicable"}
                                // menuPortalTarget={null}
                              ></SearchableSelect>
                            </td>
                            <td>
                              <MultiSelectTwo
                                options={BODY_PART_LIST.map((d) => ({
                                  ...d,
                                  disabled:
                                    d.value === "notApplicable" &&
                                    x?.bodyParts === "notApplicable"
                                      ? false
                                      : x?.bodyParts === "Not Applicable" ||
                                        !x?.bodyParts ||
                                        x?.bodyParts !== "notApplicable"
                                      ? false
                                      : true,
                                }))}
                                value={x?.bodyParts
                                  ?.split(",")
                                  .map((id) => {
                                    const found = BODY_PART_LIST.find(
                                      (site) => site.value === id
                                    );

                                    return found || null;
                                  })
                                  .filter((d) => !!d)}
                                onChange={(selectedSites) => {
                                  onChange(
                                    index,
                                    "bodyParts",
                                    selectedSites?.map((site) => site.value).join(",")
                                  );
                                }}
                                hasSelectAll={false}
                                isDisabled={x.injuryType === "Not Applicable"}
                                // menuPortalTarget={null}
                              />
                            </td>
                            <td>
                              <SearchableSelect
                                name="outcome"
                                onChange={({ target: { name, value } }) =>
                                  onChange(index, name, value)
                                }
                                value={x.outcome}
                                options={Object.keys(injuryOutcomes)}
                                object={injuryOutcomes}
                                disabled={x.injuryType === "Not Applicable"}
                              />
                            </td>
                            <td>
                              <Input
                                name="ltiHours"
                                type="number"
                                onChange={({ target: { name, value } }) =>
                                  value >= 0 &&
                                  value <= 999999 &&
                                  onChange(index, name, value)
                                }
                                value={x.ltiHours}
                                className="form-control"
                                readOnly={x.outcome !== "lostTime"}
                              />
                              <span className="small text-danger">
                                {error[index]?.ltiHours}
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" align="center"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Srcollbar>
            </div>
          </div>

          <div className=" text-center">
            <Link
              to="/health-safety-and-environment/incident-management/view-incidents"
              className="btn btn-secondary mr-2"
            >
              Back
            </Link>
            <button onClick={() => onSubmit()} className="btn btn-primary ml-2">
              {"Update"}
            </button>
          </div>
        </div>
        {/* <ErrorPopup
          show={show}
          popupMssg={popupMssg}
          handleClose={handleClose}
          isOptionalPopup={isOptionalPopup}
        /> */}
      </div>
    </>
  );
};

export default LtiUpdateForm;
